var OptionService = require("./services/option.svc");
var StrategyService = require("./services/strategy.svc");
var {NgFormUtil} = require("../js/util/NgFormUtil");

import {ReplaySubject} from "rxjs";
import {ObjectUtil} from "../js/util/ObjectUtil";
import {isNotNull} from "../js/util/UtilFunctions";
import {ClientEventType} from "../services/client-events/models/ClientEventType";

"use strict";
{
    var app = angular.module('tf.strategy', ['tf.portfolio.widgets.strategy.payoff', 'tf.strategy.mobile', 'tf.portfolio.ticket', OptionService, StrategyService])
        .controller('strategyOptionChainCtrl', ['$scope', '$timeout', '$uibModal', '$localStorage', '$document', '$http', '$window', '$filter', 'terms', function ($scope, $timeout, $uibModal, $localStorage, $document, $http, $window, $filter, terms) {
            //Payoff diagram

            $scope.payoffView = { type: 'Diagram' };

            //end payoff diagram

            var payOffChartApi;

            $scope.payOffChartReady = function ($scope, $elem) {
                payOffChartApi = $scope.api
            };

            function resize() {
                if (payOffChartApi != null) {
                    payOffChartApi.update()
                }
            }

            var dataWatch = $scope.$watch("payoffData", function () {
                $timeout(resize);
            });

            $window.addEventListener('resize', resize);

            $scope.$on("$destroy", function () {
                $window.removeEventListener("resize", resize);
                dataWatch();
            });

            $scope.payoffDataOptions = {
                chart: {
                    type: 'lineChart',
                    height: 277,
                    //TODO needs to reflect height of window
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 50,
                        left: 70
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    interactiveLayer: {
                        tooltip: {
                            contentGenerator: function (event) {
                                var priceFilter = $filter("price");
                                var numberFormat = $filter("tfcurrency");
                                var daysFilter = $filter("daysFromNow");

                                var steps = ($scope.priceSteps.length - 1) / 2;

                                var expiry = event.series[event.series.length - 1].key;

                                var priceIndex = event.value + steps;
                                var price = $scope.priceSteps[priceIndex];
                                var header = "<h3> Price $" + priceFilter(price, $scope.points) + "</h3>";

                                var content = event.series.map(function (row) {
                                    var rowClass = row.highlight ? "highlight" : "";
                                    var valueClass = row.value < 0 ? 'sell' : 'buy';
                                    var difference = daysFilter(moment(expiry, 'MMM Do YYYY'), moment(row.key, 'MMM Do YYYY'));

                                    return "<tr class='" + rowClass + "'>" +
                                        "<td class='legend-color-guide' style='border-color: " + row.color + "'>" +
                                        "<div style='background-color:" + row.color + "'></div>" +
                                        "</td>" +
                                        "<td class='key' style='border-color: " + row.color + "'>" +
                                        row.key +
                                        "<div style='font-size: 11px'>" + difference + " days to expiry</div>" +
                                        "</td>" +
                                        "<td class='value' style='font-size: 1.1em; border-color: " + row.color + ";'>" +
                                        "<span class='" + valueClass + "'>" +
                                        numberFormat(row.value, 2) +
                                        "</span>" +
                                        "</td>" +
                                        "</tr>"
                                }).join("\n");
                                return header + "<table><tbody>" + content + "</tbody></table>"
                            }
                        }
                    },
                    dispatch: {},
                    xAxis: {
                        axisLabel: 'Price Change',
                        tickFormat: function (d) {
                            var steps = ($scope.priceSteps.length - 1) / 2;

                            var index = d + steps;
                            if ($scope.points) {
                                return d3.format(',.01f')($scope.priceSteps[index]);
                            } else {
                                return d3.format(',.03f')($scope.priceSteps[index]);
                            }
                        }

                    },
                    yAxis: {
                        axisLabel: 'Profit / Loss ($)',
                        tickFormat: function (d) {
                            return d3.format(',f')(d);
                        },
                        axisLabelDistance: 0
                    }
                }
            };

        }])
        .controller('strategyCtrl', ['$scope', '$state', '$stateParams', 'uiGridConstants', '$document', '$localStorage', 'gridUtil', '$http', '$aside', 'userConfig', 'chainService', 'openInterestService', 'moment', '$timeout', '$window', '$uibModal', '$q', 'brokers', 'ticketService', 'growl', 'terms', 'optionService', 'strategyService', 'simpleModalService', 'screenSize', 'placeOrderService', 'companyService', "accountStore", "strategyColumnService", "portfolioService", "tradingSystemsDialogService", "$location", "clientEventService",
            function strategyController($scope, $state, $stateParams, uiGridConstants, $document, $localStorage, gridUtil, $http, $aside, userConfig, chainService, openInterestService, moment, $timeout, $window, $uibModal, $q, brokers, ticketService, growl, terms, optionService, strategyService, simpleModalService, screenSize, placeOrderService, companyService, accountStore, strategyColumnService, portfolioService, tradingSystemsDialogService, $location, clientEventService) {

                $scope.filter = "";
                $scope.publish = {
                    tradeIdeaText: ''
                };

                $scope.createPosition = {
                    instrument: null,
                    quantity: null
                };

                // Because it may have been set by the parent...
                $scope.portfolio = null;

                const destroyed$ = new ReplaySubject(1);

                $scope.$on("$destroy", () => {
                    destroyed$.next(true);
                    destroyed$.complete();
                });

                accountStore.current
                            .takeUntil(destroyed$)
                            .filter(isNotNull)
                            .do((account) => console.debug("Updating strategy with portfolio", account.id, account.number, account.name))
                            .map((account) => account.id)
                            .flatMap((id) => portfolioService.portfolio(id))
                            .subscribe((positions) => {
                                $timeout(() => {
                                    $scope.portfolio = positions;
                                    $scope.portfolioId = positions.id;
                                    if ($scope.activeStrategy != null) {
                                        $scope.getStrategyResults();
                                    }
                                });
                            });

                function createStrategyFromRecipe(underlying, recipeParams) {
                    return $http.post('/tradefloor/api/strategy/kitchen', recipeParams).then(function (response) {
                        var strategyLegs = response.data;

                        if (strategyLegs.length === 0) {
                            simpleModalService.alert("Unable to find Options to satisfy strategy parameters");
                        } else {
                            var newStrategy = {
                                underlying: underlying,
                                name: underlying + ' ' + recipeParams.longName,
                                description: '',
                                gcd: 1,
                                scaleFactor: 1,
                                trades: strategyLegs,
                                type: recipeParams.name,
                                tmc: true
                            };

                            $http.put('/tradefloor/api/strategy', newStrategy).then(function (response) {
                                var strategy = response.data;

                                $scope.getStrategies().then(function () {
                                    var newStrategy = null;

                                    $scope.strategies.forEach(function (s) {

                                        if (strategy.id === s.id) {
                                            newStrategy = strategy;
                                        }
                                    });

                                    if (newStrategy) {
                                        $timeout(function () {
                                            $scope.setActiveStrategy(newStrategy);
                                            var whatifPosCreate = angular.element(document.getElementById('whatifPosCreate'));
                                            $document.scrollToElement(whatifPosCreate, 50, 1000);
                                        });
                                    }

                                });
                            });
                        }
                    });
                }

                $scope.createStrategyFromTradingSystems = async () => {
                    const recipe = await tradingSystemsDialogService.open();
                    createStrategyFromRecipe(recipe.code, recipe);
                };

                function selectCompany(code) {
                    return $scope.findCompanies(code).then(function (matches) {
                        var companyChanged = false;
                        $scope.companies.forEach(function (c) {
                            if (c.code === code) {
                                companyChanged = !$scope.company || $scope.company.code !== c.code;
                                $scope.company = c;
                            }
                        });

                        // TODO this isn't the only way we can change the company code, but it is the one most likely to change
                        if (companyChanged) {
                            $scope.onCompanyChanged();
                        }

                        return $scope.company;
                    });
                }

                if (screenSize.is('xs')) {
                    $scope.isScreenMobile = true;
                }
                else {
                    $scope.isScreenMobile = false;
                }

                $scope.brokers = brokers;

                $scope.terms = terms;

                $scope.strategyTabs = {
                    activeIndex: null
                };

                var defaultStorage = {
                    strategyTour: {
                        complete: false,
                        skipped: false
                    }
                };

                $scope.$storage = $localStorage.$default(defaultStorage);

                if ($localStorage['active_strategy']) {
                    $scope.strategyTabs.activeIndex = 'Strategy' + $localStorage['active_strategy'];
                }

                $scope.clearStockSelector = function () {
                    $scope.stock = null;
                    $scope.company = null;
                };

                $scope.onCompanyChanged = function (selected) {

                    const company = selected || $scope.company;

                    // TODO This totally doesn't work as it doesn't return the data
                    if (company == null) {
                        $scope.stock = null;
                        return $q.resolve(null);
                    }

                    // Because reasons
                    $scope.company = company;

                    var currentCompany = company.code;

                    return $http.get('/tradefloor/api/stockscreener?underlying=' + currentCompany).then(function (response) {
                        // TODO It is possible that the company was unset after the request started
                        if (!$scope.company) {
                            return;
                        }
                        response.data.forEach(function (s) {
                            if (s.underlying === currentCompany) {
                                $scope.stock = s;
                            }
                        });
                    });
                };

                // aside
                $scope.asideState = {
                    open: false
                };

                $scope.openAside = function (position, backdrop) {
                    $scope.asideState = {
                        open: true,
                        position: position
                    };

                    function postClose() {
                        $scope.asideState.open = false;
                    }

                    $aside.open({
                        templateUrl: 'app/strategybuilder/widgets/strategy/mobile/asideStrategyMenu.html',
                        placement: position,
                        size: 'md',
                        backdrop: backdrop,
                        resolve: {
                            strategies: function () {
                                return $scope.strategies;
                            },
                            strategyTabs: function () {
                                return $scope.strategyTabs;
                            },
                            activeStrategy: function () {
                                return $scope.activeStrategy;
                            }

                        },
                        controller: 'strategyAsideCtrl as strategyAsideCtrl'
                    }).result.then(postClose, postClose);
                };

                // end aside

                $scope.Math = Math;

                $scope.volModifiers = {
                    up: [
                        {value: 0.15},
                        {value: 0.50},
                        {value: 0.75},
                        {value: 1.00}
                    ],
                    down: [
                        {value: -0.75},
                        {value: -0.50},
                        {value: -0.15}
                    ],
                    selected: {
                        up: null,
                        down: null
                    }
                };

                $scope.volModifiers.selected.up = $scope.volModifiers.up[1];
                $scope.volModifiers.selected.down = $scope.volModifiers.down[1];

                $scope.selectVolModifier = function (value, up) {
                    if (up) {
                        $scope.volModifiers.selected.up = value;
                    } else {
                        $scope.volModifiers.selected.down = value;
                    }

                    $scope.updateStrategy();
                };

                $scope.strategyBuilder = 'ZzPNLlHN9S0';

                $scope.loadListsData = function () {
                    $scope.$broadcast('strategy.changed', $scope.activeStrategy);
                };
                $scope.selectAllocations = function () {
                    $scope.allocationsActive = true;
                    $scope.$broadcast('strategy.changed', $scope.activeStrategy);
                };
                $scope.selectResults = function () {
                    $scope.allocationsActive = false;
                };
                $scope.allocationsActive = false;

                $scope.openStockScreener = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/apps/stockScreener/stockScreener.tpl.html',
                        controller: 'stockScreenerCtrl as stockScreenerCtrl',
                        size: 'fs',
                        windowClass: 'fsModalScreener',
                        resolve: {
                            actionText: function () {
                                return 'View in Strategy Builder'
                            }
                        }
                    });

                    modalInstance.result.then(function (underlying) {
                        $scope.createStrategy(underlying);
                    });
                };

                $scope.openDisclaimer = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/layout/brokerDisclaimer/brokerDisclaimer.tpl.html',
                        controller: 'brokerDisclaimerCtrl as brokerDisclaimerCtrl',
                        size: 'lg',
                        resolve: {
                            broker: function () {
                                return brokers[$scope.activeStrategy.sourceBroker];
                            }
                        }
                    });
                };

                $scope.clearStrategy = function () {
                    $scope.activeStrategy.tradeDetails = [];
                    $scope.updateStrategy();
                };

                $scope.cloneStrategy = async function (strategy) {
                    const newStrategy = await strategyService.clone(strategy);
                    await $scope.getStrategies();
                    $scope.setActiveStrategyFromId(newStrategy.id);
                };

                $scope.reverseStrategy = function () {
                    $scope.activeStrategy.tradeDetails.forEach(function (t) {
                        t.quantity = -t.quantity;
                    });
                    $scope.updateStrategy();
                };

                $scope.moveStrikesUp = function () {
                    optionService.moveStrikesUp($scope.activeStrategy.underlying, $scope.activeStrategy.tradeDetails, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            $scope.activeStrategy.tradeDetails = updated;
                            $scope.updateStrategy();
                        });
                };

                $scope.moveStrikesDown = function () {
                    optionService.moveStrikesDown($scope.activeStrategy.underlying, $scope.activeStrategy.tradeDetails, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            $scope.activeStrategy.tradeDetails = updated;
                            $scope.updateStrategy();
                        });
                };

                $scope.moveExpiriesOut = function () {
                    optionService.moveExpiriesOut($scope.activeStrategy.underlying, $scope.activeStrategy.tradeDetails, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            $scope.activeStrategy.tradeDetails = updated;
                            $scope.updateStrategy();
                        });
                };

                $scope.moveExpiriesIn = function () {
                    optionService.moveExpiriesIn($scope.activeStrategy.underlying, $scope.activeStrategy.tradeDetails, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            $scope.activeStrategy.tradeDetails = updated;
                            $scope.updateStrategy();
                        });
                };

                $scope.nextStrike = function (position) {
                    optionService.nextStrike(position, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            Object.assign(position, updated);
                            $scope.updateStrategy();
                        });
                };

                $scope.previousStrike = function (position) {
                    optionService.previousStrike(position, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            Object.assign(position, updated);
                            $scope.updateStrategy();
                        });
                };

                $scope.nextExpiry = function (position) {
                    optionService.nextExpiry(position, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            Object.assign(position, updated);
                            $scope.updateStrategy();
                        });
                };

                $scope.previousExpiry = function (position) {
                    optionService.previousExpiry(position, $scope.activeStrategy.trades)
                        .then(function (updated) {
                            Object.assign(position, updated);
                            $scope.updateStrategy();
                        });
                };

                $scope.visibleColumns = strategyColumnService.current();

                $scope.updateVisibleColumns = () => {
                    strategyColumnService.open($scope.visibleColumns)
                                         .subscribe(columns => $scope.visibleColumns = columns);
                };

                function resetCreatePositionForm() {
                    $scope.createPosition.instrument = null;
                    $scope.createPosition.quantity = null;
                    Array.from(newPositionForm)
                        .map(e => angular.element(e))
                        .map(c => c.controller("form"))
                        .forEach(f => {
                            NgFormUtil.setPristine(f);
                        });
                }

                $scope.addToStrategy = function (instrument, quantity) {
                    if (!instrument) {
                        return;
                    }

                    if (instrument.length < 4 && $scope.activeStrategy.equityTradeDetails.length > 0) {
                        var message = "Only one Equity leg is allowed per strategy.";
                        growl.error(message, {title: 'Max Equity legs added.'});
                        return;
                    }

                    quantity = quantity || $scope.activeStrategy.scaleFactor;
                    var underlying = instrument.substring(0, 3);

                    var tradeToAdd = {
                        code: instrument,
                        quantity: quantity
                    };

                    if (!$scope.activeStrategy || $scope.activeStrategy.underlying !== underlying) {
                        if ($scope.preventDoubleClick) {
                            return;
                        }
                        $scope.preventDoubleClick = true;
                        $scope.createStrategy(underlying, [tradeToAdd]);
                        resetCreatePositionForm();

                        return;
                    }

                    var exists = false;
                    var trades = $scope.activeStrategy.trades || [];

                    for (var i = 0; i < trades.length; i++) {
                        if (trades[i].code === tradeToAdd.code) {
                            exists = true;
                        }
                    }
                    if (!exists) {
                        trades.push(tradeToAdd);
                    }

                    $http.post('/tradefloor/api/strategy/' + $scope.activeStrategy.id + '/trades', trades)
                        .then(function (response) {
                            var result = response.data;
                            $scope.activeStrategy.trades = result;
                            $scope.getStrategyResults().then(function () {
                                resetCreatePositionForm();

                                $scope.preventDoubleClick = false;
                            });
                        })
                };

                const processStrategyResults = async (results) => {
                    $scope.gcd = results.gcd;
                    $scope.strategyMovements = results.strategyMovements;
                    $scope.strategyMovements.reverse();
                    $scope.updatePayoff(results.payoffSummary);
                    $scope.timeDecay = results.timeDecay;
                    $scope.maxLoss = results.maxLoss;
                    $scope.maxGain = results.maxGain;
                    $scope.buyingPower = results.buyingPower;
                    $scope.baseStrategy = results.baseStrategy;
                    $scope.activeStrategy = results.strategy;
                    $scope.netTheo = results.netTheo;

                    $scope.optionTrades = $scope.activeStrategy.trades.filter(tr => tr.code.length > 3);
                    $scope.equityTrades = $scope.activeStrategy.trades.filter(tr => tr.code.length === 3);

                    const payoffTrades = $scope.activeStrategy
                                               .tradeDetails
                                               .map((tr) => ObjectUtil.copy(tr))
                                               .map((tr) => Object.assign(tr, { quantity: tr.total }))
                                               .map((tr) => ObjectUtil.pick(tr, "id", "code", "quantity", "strategyQuantity"));
                    const payoffEquityTrades = $scope.activeStrategy
                                                     .equityTradeDetails
                                                     .map((tr) => ObjectUtil.copy(tr))
                                                     .map((tr) => Object.assign(tr, { code: tr.underlyingCode, quantity: tr.quantity, strategyQuantity: tr.quantity }))
                                                     .map((tr) => ObjectUtil.pick(tr, "id", "code", "quantity", "strategyQuantity"));

                    $scope.payoffInput = {
                        id: $scope.activeStrategy.id,
                        optionTrades: payoffTrades,
                        equityTrades: payoffEquityTrades
                    };

                    $scope.$broadcast('strategy.changed', $scope.activeStrategy);
                };

                $scope.getStrategyResults = async () => {
                    if ($scope.activeStrategy == null) {
                        return;
                    }
                    const timeSeries = $scope.inputs.timeSeries;
                    const pricePoints = $scope.inputs.pricePoints;
                    const volUp = $scope.volModifiers.selected.up.value;
                    const volDown = $scope.volModifiers.selected.down.value;
                    if ($scope.portfolio != null) {
                        const results = await strategyService.portfolioStrategyResults($scope.portfolio, $scope.activeStrategy, timeSeries, pricePoints, volUp, volDown);
                        processStrategyResults(results);
                    } else {
                        const results = await strategyService.strategyResults($scope.activeStrategy, timeSeries, pricePoints, volUp, volDown);
                        processStrategyResults(results);
                    }
                };

                clientEventService.events()
                                  .filter((evt) => evt.type === ClientEventType.BROKER_STATE_CHANGED)
                                  .takeUntil(destroyed$)
                                  .subscribe(() => $scope.getStrategyResults());

                $scope.timeSeries = {
                    value: 3,
                    options: {
                        floor: 2,
                        ceil: 8,
                        onEnd: function (id) {
                            $scope.getStrategyResults();
                        }
                    }
                };

                $scope.pricePoints = {
                    value: 5,
                    options: {
                        floor: 5,
                        ceil: 35,
                        onEnd: function (id) {
                            $scope.getStrategyResults();
                        }
                    }
                };

                $scope.getStrategies = function () {
                    return $http.get('/tradefloor/api/strategy')
                        .then(function (response) {
                            $scope.strategies = response.data;
                        });
                };

                function createStrategy(underlying, trades, tmc, name, description) {
                    var newStrategy = {
                        underlying: underlying,
                        name: name,
                        description: description,
                        trades: trades || [],
                        tmc: tmc
                    };
                    return $http.put('/tradefloor/api/strategy', newStrategy)
                        .then(function (response) {
                            var data = response.data;
                            $scope.strategies.push(data);
                            // TODO timeout is needed here to wait for the tabs to draw so they can select correctly
                            $timeout(function () {
                                $scope.setActiveStrategy(data);

                                var widgetTop = angular.element(document.getElementById('widget-grid'));
                                $document.scrollToElement(widgetTop, 50, 1000);

                            }, 0);

                        });
                }

                $scope.createStrategy = function (code, trades) {
                    var strategyName = code + " Strategy " + ($scope.strategies.length + 1);
                    return createStrategy(code, trades, false, strategyName, '');
                };

                // One off watch for the active strategy being set, which means the tabs have rendered
                function awaitTabs(fn) {
                    var watch = null;
                    watch = $scope.$watch("activeStrategy", function () {
                        $timeout(fn);
                        if (watch != null) {
                            watch();
                        }
                    });
                }

                $scope.getStrategies().then(function () {
                    if ($stateParams.clone) {
                        $http.post('/tradefloor/api/strategy/' + $stateParams.clone + '/clone').then(function (response) {
                            $localStorage['active_strategy'] = response.data;
                            $localStorage.$apply();

                            // TODO this is a hack to remove the clone param from the URL
                            $state.go('strategy', {clone: null});
                        });
                    }

                    if ($stateParams.noUnderlying) {
                        awaitTabs($scope.clearStockSelector);
                    } else if ($stateParams.underlying) {
                        $location.search({});
                        $scope.createStrategy($stateParams.underlying);
                    } else if (!$stateParams.fromIntro && !$scope.$storage.strategyTour.complete) {

                        selectCompany('CBA').then(function (c) {
                            // For the first run where we aren't coming from the intro we create a sample long call for CBA
                            return chainService(c.code).then(function (chain) {

                                var monthlyExpiries = chain.series.filter(function (s) {
                                    return s.expiryType !== 'WEEKLY' && moment().add(3, 'days').isBefore(moment(s.expiry));
                                });

                                var firstMonthlyExpiry = monthlyExpiries[0];

                                var recipeParams = {
                                    name: 'long_call',
                                    longName: 'Long Call',
                                    expiryDate: firstMonthlyExpiry.expiry,
                                    code: c.code,
                                    style: null,
                                    legs: [{
                                        optionType: 'CALL',
                                        priceWeight: 0,
                                        size: 1,
                                        timeOffset: 0
                                    }]
                                };

                                createStrategyFromRecipe(c.code, recipeParams).then(function () {
                                    // This is on a timeout because the active tab is set lazily
                                    $timeout(function () {
                                        $scope.startStrategyTour = true;
                                    });
                                });
                            });
                        });
                    } else {

                        if ($scope.strategies.length > 0) {
                            awaitTabs(function () {
                                $scope.startStrategyTour = !$scope.$storage.strategyTour.complete;

                                if ($stateParams.fromIntro) {
                                    // The newly created strategy should already be selected once they get here
                                    // The alert is only in a timeout so that the change had actually happened by the time the window popped up
                                    $timeout(function () {
                                        $scope.startStrategyTour = true;
                                    });
                                }
                            })
                        }

                        var idToSelect = $stateParams.activeStrategy || ($localStorage['active_strategy'] && +$localStorage['active_strategy']);
                        var found = false;

                        if (idToSelect != null) {
                            $scope.strategies.forEach(function (strategy) {
                                if (idToSelect == strategy.id) {
                                    $scope.setActiveStrategy(strategy);
                                    found = true;
                                }
                            });
                        }

                        if (!found) {
                            $scope.setActiveStrategy($scope.strategies[0]);
                        }
                    }
                });

                $scope.deleteStrategy = function (strategy) {
                    $http.delete('/tradefloor/api/strategy/' + strategy.id)
                        .then(function (response) {
                            $scope.strategies = $scope.strategies.filter(function (s) {
                                return s != strategy;
                            });

                            if ($scope.strategies.length === 0) {
                                $scope.activeStrategy = null;
                                $localStorage['active_strategy'] = null;
                                $scope.strategyTabs.activeIndex = null;
                            } else {
                                $scope.setActiveStrategy($scope.strategies[0]);
                            }
                        })
                };

                $scope.deleteAll = function () {
                    $scope.activeStrategy = null;
                    $localStorage['active_strategy'] = null;
                    $scope.strategyTabs.activeIndex = null;

                    $scope.strategies.forEach(function (s) {
                        $scope.deleteStrategy(s);
                    });
                };

                $scope.setActiveStrategyFromId = function(id) {
                    const strategy = $scope.strategies.find((strat) => strat.id === id);
                    $scope.setActiveStrategy(strategy);
                };

                $scope.setActiveStrategy = function (strategy) {
                    var ret = null;
                    if ($scope.activeStrategy !== strategy) {
                        $scope.activeStrategy = strategy;

                        if (strategy.underlying) {
                            selectCompany(strategy.underlying);
                        }

                        $localStorage['active_strategy'] = strategy.id;
                    } else if (strategy != null && $scope.company != null && strategy.underlying != $scope.company.code) {
                        selectCompany(strategy.underlying);
                    }
                    if ($scope.strategyTabs && $scope.activeStrategy) {
                        $scope.strategyTabs.activeIndex = 'Strategy' + $scope.activeStrategy.id;
                    }
                    if (strategy) {
                        ret = $scope.getStrategyResults();
                    } else {
                        ret = $q.resolve();
                    }
                    return ret;
                };

                $scope.updateTimeSeries = function () {
                    $scope.getStrategyResults();
                };

                $scope.updateStrategy = function () {
                    const zeroQuantityPosition = $scope.activeStrategy?.positions?.find(item => !item.quantity) ?? null;
                    if(zeroQuantityPosition) {
                        $scope.executeStrategyDisabled = true;
                        return;
                    }
                    $scope.executeStrategyDisabled = false
                    return strategyService.updateStrategy($scope.activeStrategy)
                        .then(function (strategy) {
                            $scope.activeStrategy = strategy;
                            return $scope.getStrategyResults();
                        });
                };

                $scope.deleteTrade = function (tradeId) {
                    $http.delete('/tradefloor/api/strategy/trade/' + tradeId)
                        .then(function (response) {
                            var data = response.data;
                            $scope.activeStrategy.trades = $scope.activeStrategy.trades.filter(function (trade) {
                                return trade.id !== tradeId
                            });
                            $scope.getStrategyResults();
                        })
                };

                async function reloadStrategies(activeStrategyId) {
                    await $scope.getStrategies();
                    const activeStrategy = $scope.strategies.find(strategy => strategy.id === activeStrategyId);
                    $scope.setActiveStrategy(activeStrategy);
                }

                $scope.buildTmc = async () => {
                    if ($scope.activeStrategy.tmc) {
                        await strategyService.unmakeTmc($scope.activeStrategy, false);
                        return reloadStrategies($scope.activeStrategy.id);
                    } else {
                        await strategyService.makeTmc($scope.activeStrategy, false);
                        return reloadStrategies($scope.activeStrategy.id);
                    }
                };

                $scope.updatePayoff = function (payoffData) {

                    var seriesData = payoffData.dateSteps.map(function (d) {
                        return {
                            key: moment(d).format('MMM Do YYYY'),
                            values: []
                        }
                    });

                    var steps = (payoffData.priceSteps.length - 1) / 2;
                    for (var i = 0; i < payoffData.priceSteps.length; i++) {

                        for (var j = 0; j < payoffData.dateSteps.length; j++) {


                            var dataPosition = j * payoffData.priceSteps.length + i;

                            seriesData[j].values.push({
                                x: i - steps,
                                y: payoffData.payOffData[dataPosition]
                            });
                        }
                    }
                    $scope.payoffDataService.points = $scope.points = payoffData.points;
                    $scope.payoffDataService.priceSteps = $scope.priceSteps = payoffData.priceSteps;
                    $scope.payoffDataService.payoffData = $scope.payoffData = seriesData;
                };

                $scope.payoffDataService = {
                    points: false,
                    priceSteps: [],
                    payoffData: []
                };

                $scope.payoffData = [];

                $scope.inputs = {
                    timeSeries: 3,
                    pricePoints: 15
                };

                $scope.payoffInputService = {
                    inputs: $scope.inputs
                };

                $scope.executeStrategy = function () {
                    var today = new Date(moment($scope.portfolio.today).format());
                    placeOrderService.openOrderWindow($scope.activeStrategy,
                                                      $scope.portfolioId,
                                                      $scope.portfolio.portfolioType,
                                                      $scope.portfolio.accountName,
                                                      today);
                };

                $scope.allocateStrategy = function () {
                    $state.go('adviserLists', {strategyId: $scope.activeStrategy.id});
                };

                $scope.saveStrategy = function () {
                    if ($scope.clientPortfolios && $scope.clientPortfolios.length > 1) {
                        $scope.selectPortfolio($scope.clientPortfolios);
                    } else if ($scope.clientPortfolios) {
                        $scope.distributeStrategy($scope.clientPortfolios[0].portfolioId, $scope.activeStrategy.id);
                    }
                };

                $scope.distributeStrategy = function (portfolioId, strategyId) {
                    $http.put('api/strategy/client/' + portfolioId, strategyId)
                        .then(function (response) {
                            var data = response.data;
                            if (!$localStorage['portfolioPrefs_' + portfolioId]) {
                                $localStorage['portfolioPrefs_' + portfolioId] = {};
                            }
                            $localStorage['portfolioPrefs_' + portfolioId].selectedTab = 'WhatIf';
                            $localStorage['portfolioPrefs_' + portfolioId].activeWhatIf = data;
                            $localStorage.$apply();
                            $state.go('portfolio', {portfolioId: portfolioId, activeWhatIfId: data});
                        })
                };

                $scope.renameStrategy = function (name) {
                    $http.post('/tradefloor/api/strategy/' + $scope.activeStrategy.id + '/name', name)
                         .then(function (response) {});
                };

                $scope.updateStrategyDescription = function (description) {
                    $http.post('/tradefloor/api/strategy/' + $scope.activeStrategy.id + '/description', description)
                         .then(function (response) {});
                };

                function publishStrategy(tradeIdea) {
                    var selectedStrategy = $scope.activeStrategy;
                    $scope.publishing = true;
                    $http.post('/tradefloor/api/strategy/' + selectedStrategy.id + '/publish?tradeIdea=' + tradeIdea, $scope.publish.tradeIdeaText).then(function (response) {
                            selectedStrategy.published = true;
                            $scope.publishing = false;
                        },
                        function () {
                            // TODO Show an error
                            $scope.publishing = false;
                        });
                }

                $scope.publishStrategy = function () {
                    publishStrategy(false);
                };

                $scope.publishTradeIdea = function () {
                    publishStrategy(true);
                };

                $scope.scaleStrategy = function () {
                    if ($scope.activeStrategy.scaleFactor < 1) {
                        $scope.activeStrategy.scaleFactor = 1;
                    }
                    return $http.post('/tradefloor/api/strategy/' + $scope.activeStrategy.id + '/scale/' + $scope.activeStrategy.scaleFactor)
                        .then(function (response) {
                            $scope.activeStrategy.scaled = $scope.activeStrategy.scaleFactor > 1;
                            $scope.getStrategyResults();
                        })
                };

                $scope.findCompanies = async function (input) {
                    if ($scope.companies == null) {
                        $scope.companies = await companyService.companies(true);
                    }
                    return companyService.findCompanies($scope.companies, input);
                };

                $scope.selectPortfolio = function (portfolios) {
                    var modalInstance = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/strategybuilder/popups/clientPortfolioSelection.tpl.html',
                        controller: 'portfolioDistSelectionCtrl',
                        windowClass: 'margin-top50 inviteClient',
                        size: 'md',
                        resolve: {
                            portfolios: function () {
                                return portfolios;
                            }
                        }
                    });

                    modalInstance.result.then(function (portfolios) {
                        for (var i = 0; i < portfolios.length; i++) {
                            //todo control which portfolio you navigate to when there are multiple
                            $scope.distributeStrategy(portfolios[i].portfolioId, $scope.activeStrategy.id);
                        }
                    });
                };

                $scope.createAdHocStrategyAndOpenChain = function () {
                    if ($scope.activeStrategy && !$scope.activeStrategy.tmc && $scope.activeStrategy.underlying === $scope.company.code) {
                        $scope.openChain();
                    } else {
                        $scope.createStrategy($scope.company.code).then($scope.openChain);
                    }
                };

                $scope.openChain = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/strategybuilder/widgets/optionsChain/optionsChainModal.tpl.html',
                        controller: 'chainMobileCtrl as chainMobileCtrl',
                        size: 'xl',
                        resolve: {
                            underlying: function () {
                                return $scope.company.code;
                            }
                        }
                    });

                    return modalInstance.result.then(function (code) {
                        $scope.addToStrategy(code);
                    }, function () {
                        //$log.info('Modal dismissed at: ' + new Date());
                    });
                };

                $scope.openCookbook = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/apps/optionsCookbook/optionsCookbook.tpl.html',
                        controller: 'optionsCookbookCtrl as optionsCookbookCtrl',
                        size: 'lg',
                        resolve: {
                            asAt: function() {
                                return null;
                            },
                            code: function () {
                                return $scope.company.code;
                            },
                            expiries: function () {

                                return chainService($scope.company.code).then(function (chain) {
                                    var expiries = [];
                                    chain.series.filter(function (s) {
                                        return moment().add(3, 'days').isBefore(moment(s.expiry));
                                    }).forEach(function (s) {
                                        expiries.push({
                                            expiry: s.expiry,
                                            expiryType: s.expiryType
                                        });
                                    });
                                    return expiries;
                                });
                            }
                        }
                    });
                    modalInstance.result.then(function (recipeParams) {
                        createStrategyFromRecipe($scope.company.code, recipeParams);
                    }, function () {
                    });
                };

                $scope.openPayoffSettings = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/strategybuilder/widgets/strategy/payoffSettings.tpl.html',
                        controller: 'payoffSettingsCtrl as payoffSettingsCtrl',
                        size: 'md'
                    });
                    modalInstance.result.then(function (selectedItem) {
                        $scope.selected = selectedItem;
                    }, function () {
                    });
                };

                $scope.openMobPayoffGrid = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/strategybuilder/widgets/strategy/mobile/payoffGridMobile.tpl.html',
                        controller: 'payoffMobileGridCtrl as payoffMobileGridCtrl',
                        size: 'lg',
                        resolve: {
                            strategyMovements: function () {
                                return $scope.strategyMovements;
                            },
                            maxLoss: function () {
                                return $scope.maxLoss;
                            },
                            maxGain: function () {
                                return $scope.maxGain;
                            }


                        }
                    });
                    modalInstance.result.then(function () {

                    });
                };

                $scope.openMobPayoffDiagram = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/strategybuilder/widgets/strategy/mobile/payoffDiagramMobile.tpl.html',
                        controller: 'payoffMobileDiagramCtrl as payoffMobileDiagramCtrl',
                        size: 'lg',
                        resolve: {
                            payoffDataService: function () {
                                return $scope.payoffDataService;
                            },
                            payoffInputService: function () {
                                return $scope.payoffInputService;
                            },
                            reloadStrategy: function () {
                                return function () {
                                    $scope.getStrategyResults();
                                };
                            }


                        }
                    });
                    modalInstance.result.then(function () {

                    });
                };

                $scope.openWhatIfMobileModal = function (size) {

                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/portfolio/templates/mobileWhatIf/mobileWhatIf.tpl.html',
                        controller: 'optionPickerCtrl',
                        size: size,
                        resolve: {
                            stock: function () {
                                return $scope.company;
                            }
                        }

                    });

                    modalInstance.result.then(function (selectedPositions) {
                        selectedPositions.forEach(function (p) {
                            $scope.addToStrategy(p.code);
                        });
                    }, function () {
                        //$log.info('Modal dismissed at: ' + new Date());
                    });

                };

                $scope.openMobChart = function () {
                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/strategybuilder/widgets/strategy/mobile/chart.tpl.html',
                        controller: 'payoffChartCtrl as payoffChartCtrl',
                        size: 'lg',
                        resolve: {
                            symbol: function () {
                                return $scope.company;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    });
                };

                //setup Joyride

                $scope.configStrategyTour = [];

                function setupStrategyJoyride() {
                    $scope.configStrategyTour = [];

                    $scope.configStrategyTour.push({
                            type: "title",
                            heading: "Welcome to the Strategy Builder screen",
                            text:
                                '<span>On this screen we can construct option strategies before we execute them.</span>'
                        }
                    );

                    if (screenSize.is('md, lg')) {
                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder .tab-pane.active #premiumColumn",
                                heading: "Premium",
                                text: '<span>The cost of the strategy is the total premium of the trade. A negative <span class="sell">red</span> figure represents the cash that you need to pay for the strategy (a <span class="sell">debit</span> trade).</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );
                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder .tab-pane.active #marginColumn",
                                heading: "Margin",
                                text:
                                    '<span>Some strategies will require you to pay and maintain a margin. The total cost of the trade is <strong>premium <i>less</i> margin</strong>.</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );
                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder .tab-pane.active #qtyColumn",
                                heading: "Quantity",
                                text:
                                    '<span>Once you have built a strategy, you will need to come up with how much you are willing to risk on a trade. </span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder #estCost",
                                heading: "Position Sizing",
                                text:
                                    '<span>This value is the cost of your trade and any margin changes.</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder .tab-pane.active input",
                                heading: "Scale Strategy",
                                text:
                                    '<span>Update the quantity to scale the strategy up and down until you have the buying power you want</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "function",
                                fn: function (forward) {

                                    var scaleFactor = 1;

                                    if (forward) {
                                        scaleFactor = Math.ceil(1250 / Math.abs($scope.baseStrategy.cashEffect)) || 1;
                                    }

                                    if ($scope.activeStrategy.tmc && ($scope.activeStrategy.tradeDetails.length + $scope.activeStrategy.equityTradeDetails.length) > 1) {
                                        $scope.activeStrategy.scaleFactor = scaleFactor;
                                        $scope.scaleStrategy();
                                    } else {
                                        $scope.activeStrategy.tradeDetails[0].quantity = scaleFactor;
                                        $scope.updateStrategy();
                                    }
                                }
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder #estCost",
                                heading: "Position Sizing",
                                text:
                                    '<span>The estimated cost is now in the range we want</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        if ($scope.portfolio != null) {
                            $scope.configStrategyTour.push(
                                {
                                    type: "element",
                                    selector: "#strategyBuilder #viewPortfolio",
                                    heading: "Add Strategy to Portfolio",
                                    text:
                                        '<span>Once you are happy to proceed you can click this button to add to the portfolio and execute from there. This is a good idea because you may receive some margin offsets from other strategies in your portfolio.</span>',
                                    placement: "top",
                                    scroll: true,
                                    attachToBody: true
                                }
                            );
                        }
                    }
                    else {
                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder #estCostMobile",
                                heading: "Position Sizing",
                                text:
                                    '<span>At TradeFloor, as a rule of thumb, we suggest you risk between 1% to 5% of capital on a single trade. So for a $50,000 account, this figure should equal about <strong>$1,200-$1,750</strong>.</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#strategyBuilder .tab-pane.active #strategyQuantity",
                                heading: "Scale Strategy",
                                text:
                                    '<span>Update the quantity to scale the strategy up and down until you have the buying power you want</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "function",
                                fn: function () {
                                    var scaleFactor = Math.ceil(1250 / Math.abs($scope.baseStrategy.cashEffect)) || 1;
                                    $scope.activeStrategy.scaleFactor = scaleFactor;
                                    $scope.scaleStrategy();
                                }
                            }
                        );

                        $scope.configStrategyTour.push(
                            {
                                type: "element",
                                selector: "#estCostMobile",
                                heading: "Position Sizing",
                                text:
                                    '<span>The estimated cost is now in the range we want</span>',
                                placement: "top",
                                scroll: true,
                                attachToBody: true
                            }
                        );

                        if ($scope.portfolio != null) {
                            $scope.configStrategyTour.push(
                                {
                                    type: "element",
                                    selector: "#viewPortfolioMobile",
                                    heading: "Add Strategy to Portfolio",
                                    text:
                                        '<span>Once you are happy to proceed you can click this button to add to the portfolio and execute from there. This is a good idea because you may receive some margin offsets from other strategies in your portfolio.</span>',
                                    placement: "top",
                                    scroll: true,
                                    attachToBody: true
                                }
                            );
                        }
                    }
                }

                //end setup joyride
                if (userConfig.branding === 'GAME' || userConfig.branding === 'TRADEON') {
                    $state.current.data.startTour = function () {
                        $scope.startStrategyTour = true;
                    };
                }
                setupStrategyJoyride();

                $scope.onFinishTour = function (completed) {
                    $scope.startStrategyTour = false;
                    $scope.$storage.strategyTour.complete = true;
                    $scope.$storage.strategyTour.skipped = !completed;
                };
            }])

        .controller('payoffSettingsCtrl', ['$scope', '$uibModalInstance', '$timeout', function payoffSettingsCtrl($scope, $uibModalInstance, $timeout) {
            $scope.ok = function () {
                $uibModalInstance.close();
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss();
            };

            $scope.togglePriceOption = function () {
                $scope.priceOptionOn = !$scope.priceOptionOn;
            };

            $timeout(function () {
                $scope.$broadcast('rzSliderForceRender');
            }, 0, false);

            $scope.priceSlider1 = {
                min: 5000,
                max: 5400,
                options: {
                    floor: 4500,
                    ceil: 6500
                }
            };

            $scope.priceSlider2 = {
                min: 20,
                max: 30,
                options: {
                    floor: 10,
                    ceil: 40
                }
            };

            $scope.priceSlider3 = {
                min: 25,
                max: 35,
                options: {
                    floor: 15,
                    ceil: 60
                }
            };
            $scope.refreshSlider = function () {
                $timeout(function () {
                    $scope.$broadcast('rzSliderForceRender');
                });
            };

        }])

        .controller('portfolioDistSelectionCtrl', ['$scope', 'portfolios', '$uibModalInstance', function portfolioDistSelectionController($scope, portfolios, $uibModalInstance) {

            for (var i = 0; i < portfolios.length; i++) {
                portfolios[i].selected = false;
            }

            $scope.portfolios = portfolios;

            $scope.ok = function () {
                var selectedPortfolios = $scope.portfolios.filter(function (p) {
                    return p.selected;
                });
                if (selectedPortfolios) {
                    $uibModalInstance.close(selectedPortfolios);
                } else {
                    $uibModalInstance.dismiss('cancel');
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };


        }]);
}
